/** @format */

import { observable, action, computed } from 'mobx';
import database from '../firebase/config';
import UserStore from './UserStore';
import { getTimestamp } from '../helpers/getTimestamp';

class Notifications {
  @observable notifications = [];
  @observable notificationsLoaded = false;

  @action fetchNotifications = () => {
    let notificationsRef;
    if (UserStore.user.role === 'warehouse') {
      notificationsRef = database
        .ref(
          'notifications/' + UserStore.user.role + '/' + UserStore.user.whZone,
        )
        .orderByChild('/timestamp/')
        .limitToFirst(10);
    } else {
      notificationsRef = database
        .ref('notifications/sellers/')
        .orderByChild('/timestamp/')
        .limitToFirst(10);
    }

    notificationsRef.on('value', snapshot => {
      let notifications = snapshot.val();
      this.notifications = [];
      if (notifications !== undefined && notifications !== null) {
        const response = snapshot.val();
        const notificationsKeys = Object.keys(response);
        notificationsKeys.forEach(key => {
          this.notifications.push({ ...notifications[key], id: key });
        });
        this.notifications = this.notifications.reverse();
        this.notificationsLoaded = true;
      }
    });
  };

  @action isNew = (notification, userUid) => {
    let isNew = true;
    if (notification.openedBy !== null && notification.openedBy !== undefined) {
      if (Object.values(notification.openedBy).includes(userUid)) {
        isNew = false;
      }
    }
    return isNew;
  };

  @action openNotification = (id, type) => {
    let notificationRef;
    switch (type) {
      case 'newRequest':
      case 'updateRequest':
        notificationRef = database.ref(
          '/notifications/warehouse/' +
            UserStore.user.whZone +
            '/' +
            id +
            '/openedBy',
        );
        notificationRef.push(UserStore.user.uid);
      // break;
      // eslint-disable-next-line
      case 'requestChecked':
        notificationRef = database.ref(
          '/notifications/sellers/' + id + '/openedBy',
        );
        notificationRef.push(UserStore.user.uid);
        break;
      default:
        break;
    }
  };

  @action createNotification = (requestId, whZones, type) => {
    let newNotification = {
      timestamp: getTimestamp(),
      type: type,
      url: '/requests/' + requestId + '/view/',
      whZones: whZones,
    };

    switch (type) {
      case 'newRequest':
      case 'updateRequest':
        Object.values(whZones).forEach(whZone => {
          const notificationRef = database.ref(
            '/notifications/warehouse/' + whZone,
          );
          const notificationRefAll = database.ref(
            '/notifications/warehouse/all',
          );
          notificationRef.push(newNotification);
          notificationRefAll.push(newNotification);
        });
        break;
      case 'requestChecked':
        const notificationRef = database.ref('/notifications/sellers/');
        notificationRef.push(newNotification);
        break;
      default:
    }
  };

  @computed get newCount() {
    let count = 0;
    this.notifications.forEach(notification => {
      if (
        notification.openedBy !== undefined &&
        notification.openedBy !== null
      ) {
        if (
          !Object.values(notification.openedBy).includes(UserStore.user.uid)
        ) {
          count += 1;
        }
      } else {
        count += 1;
      }
    });
    return count;
  }
}

export default new Notifications();
